import { Tag } from 'antd';
import styled from 'styled-components';
import NativeNumber from '../../component/Numeral';
import { useAppSelector } from '../../methods/redux/hooks';

const StatusCountStyle = styled.div`
	& > * {
		padding: 7px 15px;
		margin-right: 10px;
		margin-bottom: 10px;
	}
`;

const StatusCount = () => {
	const { withdrawalRequestCount } = useAppSelector(
		(store: any) => store.withdrawalRequests
	);
   console.log('withdrawalRequestCount', withdrawalRequestCount);
	return (
		<StatusCountStyle>
			<Tag color="yellow">
				<p>Review</p>
				<p>
					<NativeNumber value={withdrawalRequestCount.review} />
				</p>
			</Tag>
			<Tag color="orange">
				<p>Pending</p>
				<p>
					<NativeNumber value={withdrawalRequestCount.pending} />
				</p>
			</Tag>
			<Tag color="blue">
				<p>Processing</p>
				<p>
					<NativeNumber value={withdrawalRequestCount.processing} />
				</p>
			</Tag>
			<Tag color="maroon">
				<p>Retry</p>
				<p>
					<NativeNumber value={withdrawalRequestCount.retry} />
				</p>
			</Tag>
			<Tag color="red">
				<p>On Hold</p>
				<p>
					<NativeNumber value={withdrawalRequestCount.hold} />
				</p>
			</Tag>
			<Tag color="green">
				<p>Completed</p>
				<p>
					<NativeNumber value={withdrawalRequestCount.success} />
				</p>
			</Tag>
			<Tag color="gray">
				<p>Cancelled</p>
				<p>
					<NativeNumber value={withdrawalRequestCount.cancelled} />
				</p>
			</Tag>
			<Tag
				color={Number(withdrawalRequestCount.failed) > 0 ? 'maroon' : 'gray'}
			>
				<p>Failed</p>
				<p>
					<NativeNumber value={withdrawalRequestCount.failed} />
				</p>
			</Tag>
			<Tag color="gray">
				<p>Refunded</p>
				<p>
					<NativeNumber value={withdrawalRequestCount.refunded} />
				</p>
			</Tag>
			<Tag color="gray">
				<p>Deleted</p>
				<p>
					<NativeNumber value={withdrawalRequestCount.deleted} />
				</p>
			</Tag>
		</StatusCountStyle>
	);
};

export default StatusCount;
